import React from 'react';
import HeadLineThird from '../../atoms/HeadLineThird';
import Label from '../../atoms/Label';
import { MESSAGE_MASTER_KEYS, MasterInfoState, getMessageFromMasterInfo } from '../../../redux/reducers/MasterInfoReducer';

export interface VisitStoreNotSelectedProps {
  masterInfo: MasterInfoState;
  availableStoreCnt: number;
  isShowVisitSelectStoreModal: boolean;
}

const VisitStoreNotSelectedMessage: React.FC<VisitStoreNotSelectedProps> = ({
  masterInfo,
  availableStoreCnt,
  isShowVisitSelectStoreModal,
}) => {
  // タイトル
  const title = getMessageFromMasterInfo(masterInfo, MESSAGE_MASTER_KEYS.M_0015);
  // メッセージ
  let messageId: MESSAGE_MASTER_KEYS;
  if (!isShowVisitSelectStoreModal) {
    messageId = MESSAGE_MASTER_KEYS.M_0016;
  } else {
    messageId = availableStoreCnt > 0 ? MESSAGE_MASTER_KEYS.M_0017 : MESSAGE_MASTER_KEYS.M_0018;
  }
  const message = getMessageFromMasterInfo(masterInfo, messageId);

  return (
    <div className='container u-h-full u-pt216'>
      <div className='u-text-center u-text-placeholder'>
        <HeadLineThird className='u-text-bold u-text-5l' text={title} data-testid='visit-store-not-selected--title' />
        <Label className='u-text-2l u-mt4' label={message} data-testid='visit-store-not-selected--message' />
      </div>
    </div>
  );
};
export default VisitStoreNotSelectedMessage;
